import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { TestimonialVideoItem } from "@/sanity/sanity.types";
import Image from "@/components/common/image/image";
import imageUrl from "@/sanity/utilities/imageUrl";
import ReactPlayer from "react-player";
import { useGtm } from "@/hooks/useGtm";
import { GtmVideoEvent } from "@/components/third-party-scripts/google-tag-manager/gtm-events-types";
import { ImageLoading } from "@/utilities/imageLoading";
interface IHomeVideoCardProps {
  data: TestimonialVideoItem;
  className?: string;
}
const HomeVideoCard = props => {
  const $ = _c(74);
  const {
    data
  } = props;
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const {
    track
  } = useGtm();
  const {
    youtubeUrl,
    caption,
    author,
    badge
  } = data;
  let t0;
  let t1;
  if ($[0] !== isVideoOpen) {
    t0 = () => {
      if (isVideoOpen) {
        setIsLoading(true);
        setHasError(false);
      }
    };
    t1 = [isVideoOpen];
    $[0] = isVideoOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== track) {
    t2 = (event, url) => {
      if (!url) {
        return;
      }
      track(event, {
        videoUrl: url
      });
    };
    $[3] = track;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const trackVideoEvent = t2;
  let t3;
  if ($[5] !== track || $[6] !== youtubeUrl) {
    t3 = () => {
      setIsVideoOpen(true);
      track("cta_click", {
        ctaNameId: "video-modal-play-button",
        ctaSelection: youtubeUrl
      });
    };
    $[5] = track;
    $[6] = youtubeUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handlePlayClick = t3;
  let handleCloseVideo;
  let handleModalCloseClick;
  if ($[8] !== track || $[9] !== youtubeUrl) {
    handleModalCloseClick = () => {
      handleCloseVideo();
      track("cta_click", {
        ctaNameId: "video-modal-close-button",
        ctaSelection: youtubeUrl
      });
    };
    handleCloseVideo = () => {
      setIsVideoOpen(false);
      setIsLoading(true);
      setHasError(false);
    };
    $[8] = track;
    $[9] = youtubeUrl;
    $[10] = handleCloseVideo;
    $[11] = handleModalCloseClick;
  } else {
    handleCloseVideo = $[10];
    handleModalCloseClick = $[11];
  }
  let t4;
  if ($[12] !== handleCloseVideo || $[13] !== track || $[14] !== youtubeUrl) {
    t4 = e => {
      if (e.target === e.currentTarget) {
        handleCloseVideo();
        track("cta_click", {
          ctaNameId: "video-modal-backdrop",
          ctaSelection: youtubeUrl
        });
      }
    };
    $[12] = handleCloseVideo;
    $[13] = track;
    $[14] = youtubeUrl;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const handleBackdropClick = t4;
  let t5;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsLoading(false);
    };
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const handleVideoReady = t5;
  let t6;
  if ($[17] !== trackVideoEvent || $[18] !== youtubeUrl) {
    t6 = error => {
      console.error("Video error:", error);
      setHasError(true);
      setIsLoading(false);
      trackVideoEvent("video_error", youtubeUrl);
    };
    $[17] = trackVideoEvent;
    $[18] = youtubeUrl;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const handleVideoError = t6;
  let t7;
  if ($[20] !== trackVideoEvent || $[21] !== youtubeUrl) {
    t7 = () => {
      setIsLoading(false);
      trackVideoEvent("video_start", youtubeUrl);
    };
    $[20] = trackVideoEvent;
    $[21] = youtubeUrl;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const handleVideoStart = t7;
  let t8;
  if ($[23] !== trackVideoEvent || $[24] !== youtubeUrl) {
    t8 = () => {
      trackVideoEvent("video_play", youtubeUrl);
    };
    $[23] = trackVideoEvent;
    $[24] = youtubeUrl;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const handleVideoPlay = t8;
  let t9;
  if ($[26] !== trackVideoEvent || $[27] !== youtubeUrl) {
    t9 = () => {
      trackVideoEvent("video_pause", youtubeUrl);
    };
    $[26] = trackVideoEvent;
    $[27] = youtubeUrl;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  const handleVideoPause = t9;
  let t10;
  if ($[29] !== trackVideoEvent || $[30] !== youtubeUrl) {
    t10 = () => {
      trackVideoEvent("video_seek", youtubeUrl);
    };
    $[29] = trackVideoEvent;
    $[30] = youtubeUrl;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  const handleVideoSeek = t10;
  let t11;
  if ($[32] !== trackVideoEvent || $[33] !== youtubeUrl) {
    t11 = () => {
      trackVideoEvent("video_end", youtubeUrl);
    };
    $[32] = trackVideoEvent;
    $[33] = youtubeUrl;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  const handleVideoEnded = t11;
  let t12;
  if ($[35] !== badge) {
    t12 = badge?.image ? imageUrl(badge.image).url() : "";
    $[35] = badge;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  const t13 = caption || "";
  let t14;
  if ($[37] !== badge) {
    t14 = badge?.image?.asset ? `
            ${imageUrl(badge.image.asset).width(560).url()} 560w,
            ${imageUrl(badge.image.asset).width(232).url()} 232w
          ` : undefined;
    $[37] = badge;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  const t15 = badge?.image?.asset ? "(width <= 640px) 560px, 232px" : undefined;
  let t16;
  if ($[39] !== t12 || $[40] !== t13 || $[41] !== t14 || $[42] !== t15) {
    t16 = <Image src={t12} alt={t13} width={392} height={426} className="h-auto w-full rounded-xl" srcSet={t14} sizes={t15} loading={ImageLoading.LAZY} />;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== caption) {
    t17 = <p className="mb-5 text-[18px] font-medium not-italic leading-6 text-white">{caption}</p>;
    $[44] = caption;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== author) {
    t18 = <span className="text-[16px] font-medium not-italic leading-normal text-[#D0D0D0]">{author}</span>;
    $[46] = author;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t17 || $[49] !== t18) {
    t19 = <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 text-left text-white">{t17}{t18}</div>;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="absolute bottom-4 right-4 flex h-10 w-10 items-center justify-center rounded-full shadow-md transition-all duration-500 hover:shadow-[0_0_15px_#0074a6]"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="20" fill="#00698F" /><path d="M16 25.1079V14.7524C16 13.9781 16.8421 13.4976 17.5087 13.8915L25.6451 18.6994C26.2758 19.072 26.3049 19.9739 25.6997 20.3865L17.5633 25.9341C16.8995 26.3867 16 25.9113 16 25.1079Z" fill="white" stroke="white" /></svg></div>;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== handlePlayClick || $[53] !== t16 || $[54] !== t19) {
    t21 = <div className="relative cursor-pointer overflow-hidden rounded-xl shadow-md transition-transform duration-300 hover:scale-[1.02]" onClick={handlePlayClick}>{t16}{t19}{t20}</div>;
    $[52] = handlePlayClick;
    $[53] = t16;
    $[54] = t19;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== author || $[57] !== caption || $[58] !== handleBackdropClick || $[59] !== handleModalCloseClick || $[60] !== handleVideoEnded || $[61] !== handleVideoError || $[62] !== handleVideoPause || $[63] !== handleVideoPlay || $[64] !== handleVideoSeek || $[65] !== handleVideoStart || $[66] !== hasError || $[67] !== isLoading || $[68] !== isVideoOpen || $[69] !== youtubeUrl) {
    t22 = isVideoOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" onClick={handleBackdropClick}><div className="relative w-full max-w-4xl"><button onClick={handleModalCloseClick} className="absolute -top-12 right-0 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/20 text-white transition-colors hover:bg-white/30 focus:outline-none focus:ring-2 focus:ring-white" aria-label="Close video">✕</button><div className="relative aspect-video w-full overflow-hidden rounded-lg bg-black">{isLoading && <div className="absolute inset-0 flex items-center justify-center bg-black"><div className="h-12 w-12 animate-spin rounded-full border-4 border-white/30 border-t-white" /></div>}{hasError && <div className="absolute inset-0 flex flex-col items-center justify-center bg-black text-white"><div className="mb-4 text-4xl">⚠️</div><div className="mb-2 text-lg">Failed to load video</div><div className="mb-4 text-sm text-gray-300">URL: {youtubeUrl}</div><button onClick={() => window.open(youtubeUrl, "_blank")} className="rounded bg-blue-600 px-4 py-2 text-sm hover:bg-blue-700">Open in YouTube</button></div>}<ReactPlayer src={youtubeUrl} width="100%" height="100%" playing={true} controls={true} pip={false} onReady={handleVideoReady} onStart={handleVideoStart} onError={handleVideoError} onPlay={handleVideoPlay} onPause={handleVideoPause} onSeeked={handleVideoSeek} onEnded={handleVideoEnded} config={{
            youtube: {
              playerVars: {
                modestbranding: 1,
                rel: 0,
                autoplay: 1
              }
            }
          } as any} /></div>{(caption || author) && <div className="mt-4 rounded-lg bg-white/10 p-4 backdrop-blur-sm">{caption && <p className="mb-2 text-lg font-medium text-white">{caption}</p>}{author && <p className="text-sm text-gray-300">{author}</p>}</div>}</div></div>;
    $[56] = author;
    $[57] = caption;
    $[58] = handleBackdropClick;
    $[59] = handleModalCloseClick;
    $[60] = handleVideoEnded;
    $[61] = handleVideoError;
    $[62] = handleVideoPause;
    $[63] = handleVideoPlay;
    $[64] = handleVideoSeek;
    $[65] = handleVideoStart;
    $[66] = hasError;
    $[67] = isLoading;
    $[68] = isVideoOpen;
    $[69] = youtubeUrl;
    $[70] = t22;
  } else {
    t22 = $[70];
  }
  let t23;
  if ($[71] !== t21 || $[72] !== t22) {
    t23 = <>{t21}{t22}</>;
    $[71] = t21;
    $[72] = t22;
    $[73] = t23;
  } else {
    t23 = $[73];
  }
  return t23;
};
export default HomeVideoCard;